export class User {
  email: string;
  token: string;
  username: string;
  bio: string;
  image: string;
  landingPage: string;
  dashboards: Array<any> = [];
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/shared/models/user.model.ts